module.exports = __webpack_public_path__ + "static/media/KDAA1_1.d2144e4c.png";